import {
    PracticeDetailsModel,
    PracticesClient,
    SeafaringPracticeDetailsModel,
    ShipRepairPracticeDetailsModel,
    InlandVesselPracticeDetailsModel,
    PilotagePracticeDetailsModel,
    VtsCenterPracticeDetailsModel
} from "@/api-client";


export abstract class PracticeDetailsProps {
    protected constructor(
        public readonly getDetails: (id: string) => Promise<PracticeDetailsModel>,
        public readonly detailsType: { new(): PracticeDetailsModel },
        public readonly editRouteName: string
    ) {
    }
}

export class ShipRepairPracticeDetailsProps extends PracticeDetailsProps {
    constructor(editRouteName?: string) {
        super(
            (id) => new PracticesClient().getShipRepair(id).then(details => details),
            ShipRepairPracticeDetailsModel,
            editRouteName ? editRouteName : "ship-repair-practice-edit"
        );
    }
}

export class SeafaringPracticeDetailsProps extends PracticeDetailsProps {
    constructor(editRouteName?: string) {
        super(
            (id) => new PracticesClient().getSeafaring(id).then(details => details),
            SeafaringPracticeDetailsModel,
            editRouteName ? editRouteName : "seafaring-practice-edit"
        );
    }
}

export class InlandVesselPracticeDetailsProps extends PracticeDetailsProps {
    constructor(editRouteName?: string) {
        super(
            (id) => new PracticesClient().getInlandVesselPractice(id).then(details => details),
            InlandVesselPracticeDetailsModel,
            editRouteName ? editRouteName : "inland-vessel-practice-edit"
        );
    }
}

export class PilotagePracticeDetailsProps extends PracticeDetailsProps {
    constructor(editRouteName?: string) {
        super(
            (id) => new PracticesClient().getPilotagePractice(id).then(details => details),
            PilotagePracticeDetailsModel,
            editRouteName ? editRouteName : "pilotage-practice-edit"
        );
    }
}

export class VtsCenterPracticeDetailsProps extends PracticeDetailsProps {
    constructor(editRouteName?: string) {
        super(
            (id) => new PracticesClient().getVtsCenterPractice(id).then(details => details),
            VtsCenterPracticeDetailsModel,
            editRouteName ? editRouteName : "vts-center-practice-edit"
        );
    }
}